module.exports = __webpack_public_path__ + "img/图片25.d6b9ac1a.png";